import React, { useState } from "react";
import {
  Form,
  Input,
  Button,
  Card,
  Typography,
  Divider,
  message,
} from "antd";
import { MailOutlined, LockOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import OrgService from "../../../../services/OrgService";

const { Title, Text, Link } = Typography;

const LoginForm = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false)

  const handleFinish = async(values) => {
   try {
    setLoading(true)
     const payload = {
       emailAddress: values?.email,
       password: values?.password
     }
     const response = await OrgService.Login(payload);
     if(response?.status === 200) {
      localStorage.setItem("school_details", JSON.stringify(response?.data));
      message.success("Login Succesfully");
      window.dispatchEvent(new Event("storage_updated"));
      navigate("/")
     }
   } catch (error) {
    console.log("Error occur during Login", error)
    if(error?.status === 401) {
      message.error("email or password incorrect!")
    }
   } finally {
    setLoading(false)
   }
  };

  return (
    <div
      style={{
        background: "#f0f2f5",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: "0 20px",
      }}
    >
      <Card
        style={{
          maxWidth: 450,
          width: "100%",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: "24px" }}>
          <Title level={3} style={{ margin: 0 }}>
            Welcome Back
          </Title>
          <Text type="secondary">
            Please login to your account
          </Text>
        </div>

        <Form
          layout="vertical"
          name="login_form"
          onFinish={handleFinish}
          requiredMark="optional"
        >
          <Form.Item
            name="email"
            label="Email Address"
            rules={[
              { required: true, message: "Please enter email" },
              { type: "email", message: "Please enter a valid email" },
            ]}
          >
            <Input
              prefix={<MailOutlined style={{ color: "rgba(0,0,0,.25)" }} />}
              placeholder="Email Address"
              style={{ borderRadius: "6px" }}
              className="border-input-box"
            />
          </Form.Item>

          <Form.Item
            name="password"
            label="Password"
            rules={[{ required: true, message: "Please enter password" }]}
          >
            <Input.Password
              prefix={<LockOutlined style={{ color: "rgba(0,0,0,.25)" }} />}
              placeholder="Password"
              style={{ borderRadius: "6px" }}
              className="border-input-box"
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              block
              style={{ borderRadius: "6px", fontWeight: "600", height: "45px" }}
              loading = {loading}
            >
              Login
            </Button>
          </Form.Item>
        </Form>

        <Divider style={{ margin: "12px 0" }} />

        <div style={{ textAlign: "center" }}>
          <Text type="secondary">
            Don't have an account?{" "}
            <a style={{ fontWeight: "500", color: "blue"}} onClick={() => navigate('/auth/sign-up')}>
              Create an account
            </a>
          </Text>
        </div>
      </Card>
    </div>
  );
};

export default LoginForm;